export default __webpack_public_path__ + "locales/de/SalesDepartmentRequestDialog.json?hash=2ddccaea7a66f52598f06d75081b40cd";